import { TFunction } from 'i18next';

export const getEmptyMessage = (t: TFunction, key = 'table.noRowsFound'): string => t(key);
